<template>
  <!-- <iframe id="iframe" style="display:none;"></iframe> -->
</template>

<script>
export default {
  methods: {
    redirectToApp() {
      let userAgent = navigator.userAgent;
      // let now = new Date().getTime();

      // กำหนด URLs สำหรับ iOS และ Android
      // let iosAppLink = "my_app://";
      // let androidAppLink = "my_app://";
      let iosStoreLink = "https://apps.apple.com/us/app/onebox/id6642700930";
      let androidStoreLink =
        "https://play.google.com/store/apps/details?id=com.oneplatform.onebox";

      // let appLink;
      let storeLink;

      // ตรวจสอบประเภทอุปกรณ์
      if (
        /iPhone|iPod|iPad/i.test(userAgent) ||
        (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 0)
      ) {
        // iOS/iPadOS devices
        // appLink = iosAppLink;
        storeLink = iosStoreLink;
      } else if (/Android/i.test(userAgent)) {
        // Android devices
        // appLink = androidAppLink;
        storeLink = androidStoreLink;
      } else if (/Windows NT/i.test(userAgent)) {
        // Windows PC
        storeLink = androidStoreLink;
      } else if (
        /Macintosh/i.test(userAgent) &&
        navigator.maxTouchPoints === 0
      ) {
        // Mac (non-touch)
        storeLink = iosStoreLink;
      } else {
        // fallback ไปหน้าเว็บปกติ
        storeLink = process.env.VUE_APP_UI;
      }

      // พยายามเปิดแอปโดยใช้รูปแบบ URL ที่กำหนดเอง
      // document.getElementById("iframe").src = appLink;

      // หากแอปไม่เปิด ให้ไปที่ร้านค้า
      // setTimeout(() => {
      //   let elapsed = new Date().getTime() - now;
      //   if (elapsed < 1500) {
      //     window.location.href = storeLink;
      //     setTimeout(() => {
      //       window.close();
      //     }, 1000);
      //   }
      // }, 1000);

      // ลิงก์ไปยัง Store ทันที
      window.location.href = storeLink;

      // ปิดแท็บ
      setTimeout(() => {
        window.close();
      }, 1000);
    },
  },
  mounted() {
    this.redirectToApp();
  },
};
</script>
